import FraudProtectionToken from '@/checkout/models/FraudProtectionToken'
import fraudProtectionApi from '../api/fraudProtection.api'

class FraudProtectionService {
  async token(): Promise<FraudProtectionToken> {
    try {
      return await fraudProtectionApi.token()
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export default new FraudProtectionService()
